import React from 'react';
import './EventDetails.scss';

export type EventDetailsSectionProps = {
    ariaLabelledBy?: string;
};

export const EventDetails: React.FC = ({ children }) => {
    return (
        <div className="event-details" data-testid="event-details">
            {children}
        </div>
    );
};

export const EventDetailsWrapper: React.FC = ({ children }) => {
    return <div className="event-details__wrapper">{children}</div>;
};

export const EventDetailsMain: React.FC = ({ children }) => {
    return <div className="event-details__main">{children}</div>;
};

export const EventDetailsMainInner: React.FC = ({ children }) => {
    return <div className="event-details__main-inner">{children}</div>;
};

export const EventDetailsAside: React.FC = ({ children }) => {
    return <div className="event-details__aside">{children}</div>;
};

export const EventDetailsSection: React.FC<EventDetailsSectionProps> = ({
    children,
    ariaLabelledBy,
}) => {
    return (
        <section
            aria-labelledby={ariaLabelledBy}
            className="event-details__section"
        >
            {children}
        </section>
    );
};

export const EventDetailsSectionContent: React.FC = ({ children }) => {
    return <div className="event-details__section-content">{children}</div>;
};

export const EventDetailsSectionTitle: React.FC = ({ children }) => {
    return <div className="event-details__section-title">{children}</div>;
};
